import React from 'react'
import { AsH3, ParagraphMD, TitleLG } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'

interface PayItForwardOurMissionProps {
  description: string
  className?: string
  slug?: string
}

export const PayItForwardOurMission: React.FC<PayItForwardOurMissionProps> = ({ description, className, slug }) => {
  const { t } = useTranslate('pif')

  return (
    description && (
      <section id="pay-it-forward-our-mission" className={className}>
        <TitleLG weight="bold" as={AsH3} color="core-gray-950" className="mb-4">
          {t('ourMission', 'Our Mission')}
        </TitleLG>
        <ParagraphMD color="core-gray-700">
          {slug === slugs.youngDavid
            ? description
            : t(
                'pifSupportMovementGenerosity',
                'When you Pay it Forward, you do more than support a show. You help fuel a movement. Your generosity empowers filmmakers to create new stories, helps Angel share movies and shows with audiences around the globe, and furthers our mission to tell stories that amplify light.',
              )}
        </ParagraphMD>
      </section>
    )
  )
}
